import PropTypes from 'prop-types';
import React from 'react';

import { useHotkey } from './hooks';
import { HotkeyPropType } from '../../prop-types/hotkey';

export const Hotkey = ({ children = null, hotkey }) => {
  useHotkey(hotkey);

  return <React.Fragment>{children}</React.Fragment>;
};

Hotkey.propTypes = {
  children: PropTypes.node,
  hotkey: HotkeyPropType,
};
